//   CHANGE_LINE_PX – height of one "FieldName: old → new" line (px)
const CHANGE_LINE_PX = 25;

export const MIN_ROW_HEIGHT = 35;

export const calculateDynamicRowHeight = (
  itemCount,
  { lineHeight = CHANGE_LINE_PX, minRowHeight = MIN_ROW_HEIGHT } = {}
) => {
  const count = Math.max(0, Number(itemCount) || 0);

  return Math.max(minRowHeight, count * lineHeight);
};

export const calculateChangesRowHeight = (changes, options) => {
  const changeCount = changes && typeof changes === 'object' ? Object.keys(changes).length : 0;

  return calculateDynamicRowHeight(changeCount, options);
};
